import { Box } from "@mui/material";

import { BRIEFING_STATUS_OPTIONS } from "../../../utils/briefingStatus";
import { ALERT_TONE, statusTone } from "./homeTheme";

export function statusLabel(status?: string | null): string {
  return (
    BRIEFING_STATUS_OPTIONS.find(({ value }) => value === status)?.text ??
    status ??
    "A definir"
  );
}

interface HomeChipProps {
  label: string;
  tone: { bg: string; color: string };
}

export function HomeChip({ label, tone }: HomeChipProps) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        fontSize: 11,
        fontWeight: 500,
        lineHeight: "16px",
        px: 1,
        py: "3px",
        borderRadius: "10px",
        whiteSpace: "nowrap",
        bgcolor: tone.bg,
        color: tone.color,
      }}
    >
      {label}
    </Box>
  );
}

export function StatusChip({ status }: { status?: string | null }) {
  return <HomeChip label={statusLabel(status)} tone={statusTone(status)} />;
}

export function NoApprovalChip() {
  return <HomeChip label="Sem orç. aprovado" tone={ALERT_TONE} />;
}
